import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
} from "@mui/material";

const AddDictionary = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    term: "",
    termAm: "",
    definition: "",
    definitionAm: "",
    category: "",
    categoryAm: "",
    language: "english",
    references_list: "",
    referencesAm: "",
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.term || !formData.termAm || !formData.definition || !formData.definitionAm) {
      setError("Required fields missing");
      return;
    }

    let refs = [];
    let refsAm = [];

    try {
      refs = formData.references_list ? JSON.parse(formData.references_list) : [];
      refsAm = formData.referencesAm ? JSON.parse(formData.referencesAm) : [];
    } catch {
      setError("Invalid JSON for references");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/dictionary/entries`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          references_list: refs,
          referencesAm: refsAm,
        }),
      });

      const result = await res.json();

      if (res.ok) {
        setSuccess(result.message);
        setFormData({
          term: "",
          termAm: "",
          definition: "",
          definitionAm: "",
          category: "",
          categoryAm: "",
          language: "english",
          references_list: "",
          referencesAm: "",
        });
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError("Server error");
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4">Add Dictionary Entry</Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>

          <Grid item xs={12} md={6}>
            <TextField label="Term" name="term" value={formData.term} onChange={handleChange} fullWidth required />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Term Amharic" name="termAm" value={formData.termAm} onChange={handleChange} fullWidth required />
          </Grid>

          <Grid item xs={12}>
            <TextField label="Definition" name="definition" value={formData.definition} onChange={handleChange} multiline rows={3} fullWidth required />
          </Grid>

          <Grid item xs={12}>
            <TextField label="Definition Amharic" name="definitionAm" value={formData.definitionAm} onChange={handleChange} multiline rows={3} fullWidth required />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Category" name="category" value={formData.category} onChange={handleChange} fullWidth />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Category Amharic" name="categoryAm" value={formData.categoryAm} onChange={handleChange} fullWidth />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label="Language" name="language" value={formData.language} onChange={handleChange} fullWidth />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="References JSON"
              name="references_list"
              value={formData.references_list}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
              placeholder='["ref1","ref2"]'
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="References Am JSON"
              name="referencesAm"
              value={formData.referencesAm}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained">
              Add Entry
            </Button>
          </Grid>

        </Grid>
      </form>

      <Snackbar open={!!error} message={error} onClose={() => setError(null)} />
      <Snackbar open={!!success} message={success} onClose={() => setSuccess(null)} />
    </Box>
  );
};

export default AddDictionary;